export const GET_WEEKLY_AD_DETAILS = 'GET_WEEKLY_AD_DETAILS';
export const WEEKLY_AD_DETAILS_SUCCESS = 'WEEKLY_AD_DETAILS_SUCCESS';
export const WEEKLY_AD_DETAILS_FAILURE = 'WEEKLY_AD_DETAILS_SUCCESS';
